import VerificationBoard from '@components/verification/verification-board';
import {
  DESKTOP_BREAKPOINT,
  TABLET_BREAKPOINT,
  WALLET_TRANSACTION_TYPE,
  WALLET_TRANSACTION_STATUS,
} from '@constant/system';
import useCommon from '@utils/hooks/common';
import {Button, Checkbox, Form, Layout, Modal, notification, Spin, Tabs} from 'antd';
import {getGameEventV3, SUIT, PLAYER_NOTIFICATION_TYPE} from '@constant/game';
import {autorun, toJS} from 'mobx';
import getConfig from 'next/config';
import router, {useRouter} from 'next/router';
import {useEffect, useMemo, useRef, useState} from 'react';
import dynamic from 'next/dynamic';
import MobileHeader from './MobileHeader';
import SiderBar from './sider';
import styles from './styles';
// import MultipleGameRooms from './MultipleGameRooms';
import {
  getPokerImage,
  handleJoinRoom,
  pause,
  shouldNotShowInitProfileSetting,
  shouldRedirect,
} from '@utils/index';
import classNames from 'classnames';
import CustomPopup from '@components/CustomPopup';
import DepositWithdrawModalSheet from './DepositWithdrawModalSheet';
import GradientButton from '@components/GradientButton';
import {headerHeight} from './MobileHeader/styles';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import {CURRENT_LANG_KEY} from '@utils/mobx/language';
import {env} from 'next-runtime-env';
import {ConfigProvider} from 'antd-mobile';
import enUS from 'antd-mobile/es/locales/en-US';
import zhTW from 'antd-mobile/es/locales/zh-TW';
import arSA from 'antd-mobile/es/locales/ar-SA';
import jaJP from 'antd-mobile/es/locales/ja-JP';
import koKR from 'antd-mobile/es/locales/ko-KR';
import esES from 'antd-mobile/es/locales/es-ES';
import hiIN from '@utils/i18n/antd-mobile-hi-IN';
import mnMN from '@utils/i18n/antd-mobile-mn-MN';
import {LANG_CODE} from '@constant/system';
import {init, backButton} from '@telegram-apps/sdk';
import WalletConnectSignMessageModalSheet from './WalletConnectSignMessageModalSheet';
import {isNil} from 'lodash-es';
import {isTMA} from '@telegram-apps/bridge';
import DisclaimerModal from './DisclaimerModal';
import {isMerchantGateway} from '@utils/gateway/merchant-gateway';
import TournamentNotificationsContainer from '@components/tournament/TournamentNotificationsContainer';
import {getTabBubbleRefForRoom} from '@utils/tabBubbleRefs';
import {swipeBehavior, miniApp, viewport} from '@telegram-apps/sdk';
import {isProd} from '@components/deposit-withdraw/TelegramContent';
const Lottie = dynamic(() => import('react-lottie'), {ssr: false});
import * as tableRebalance from '@public/animations-mobile/table-rebalance.json';
import {JoinedRoomProps} from 'poker-interfaces/game-room/game-room-interface';
import {useDisableDuplicateClick} from 'hooks/useDisabledDuplicatedClick';
import MultipleGameRooms from './MultipleGameRooms';
import {useInviteToRoom} from 'hooks/useInviteToRoom';

export const isTelegramMiniApp = isTMA('simple');

// const MultipleGameRooms = dynamic(() => import('./MultipleGameRooms'), {
//   ssr: false,
// });
const TooManyRoomsModalSheet = dynamic(() => import('./ModalSheets/TooManyRooms'), {
  ssr: false,
});
// const TournamentCancelModalSheet = dynamic(() => import('@components/tournament/TournamentCancelModalSheet'), {
//   ssr: false,
// }); // Moved back to table level

const {Header, Content, Footer} = Layout;

const langMap = {
  [LANG_CODE.ZH_HK]: zhTW,
  [LANG_CODE.EN_US]: enUS,
  [LANG_CODE.AR]: arSA,
  [LANG_CODE.HI]: hiIN,
  [LANG_CODE.JA]: jaJP,
  [LANG_CODE.KO]: koKR,
  [LANG_CODE.ES]: esES,
  [LANG_CODE.MN]: mnMN,
};

// TODO @@ cant get NEXT_PUBLIC_RESTRICTED_COUNTRIES
// const NEXT_PUBLIC_RESTRICTED_COUNTRIES = (env('NEXT_PUBLIC_RESTRICTED_COUNTRIES') || '').split(',');
// TODO @@ telegram
const BLOCKED_COUNTRIES = ['HKG'];
// const BLOCKED_COUNTRIES = [''];
const {publicRuntimeConfig} = getConfig();

const envValue = env('NEXT_PUBLIC_RESTRICTED_COUNTRIES');
const runtimeConfigValue = publicRuntimeConfig.NEXT_PUBLIC_RESTRICTED_COUNTRIES;

// console.log('layout - envValue, runtimeConfigValue:', envValue, runtimeConfigValue);

const notify = message => {
  const {type, content} = message;
  notification[type]({
    message: content,
  });
};

enum TAB {
  CONTENT = 1,
  GAME_ROOMS = 2,
}

const hideHeaderRoutes = [
  '/game-room',
  '/login',
  '/login/login-player',
  '/login/bullb',
  '/login-error',
  '/maintenance',
  '/loading',
  '/login-with-token',
  '/telegram',
  // '/telegram/game-list',
  '/join-with-link',
  '/fortune-wheel',
  '/w',
];

const disableDesktopPaddingRoutes = ['/fortune-wheel', '/w'];

const langToCountryMap: {[key: string]: string[]} = {
  ar: ['ARE', 'SAU', 'EGY'], // Arabic: UAE, Saudi Arabia, Egypt
  hi: ['IND'], // Hindi: India
  ja: ['JPN'], // Japanese: Japan
  ko: ['KOR'], // Korean: South Korea
  mn: ['MNG'], // Mongolian: Mongolia
  es: ['ESP', 'MEX', 'ARG', 'COL', 'CHL'],
  'zh-HK': ['TWN'],
  'en-US': ['USA', 'CAN', 'HKG'], // HKG default to eng
};

const GAME_EVENTS = getGameEventV3();

type TableExitState = {
  roomCode: string;
  isExiting: boolean;
};

const LayoutBase = ({children}: any) => {
  const {classes, session, system, user, t, theme, language, i18n, socket} = useCommon({
    withStyles: styles,
    withTranslation: ['common'],
    observers: ['session', 'system', 'socket', 'game', 'user', 'language'],
  });

  const router = useRouter();
  const {query} = router;
  const referralCode = query?.ref;

  // Handle invite to room functionality
  useInviteToRoom();

  const [isMounted, setIsMounted] = useState(false);
  const [activeTableIndex, setActiveTableIndex] = useState(0);
  const isDesktop = theme?.currentStyleFormat?.id === 'desktop';
  const [activeTab, setActiveTab] = useState(1);
  const [systemModal, setSystemModal] = useState<string>(null);
  const [isDepositModalSheetVisible, setIsDepositModalSheetVisible] = useState(false);
  const [isDisclaimerModalSheetVisible, setIsDisclaimerModalSheetVisible] =
    useState<boolean>(false);
  // const [isDisclaimerVisible, setIsDisclaimerVisible] = useState<boolean>(false);
  const [isSignMessageModalVisible, setIsSignMessageModalVisible] = useState<boolean>(false);
  const [isTooManyRoomsModalSheetVisible, setIsTooManyRoomsModalSheetVisible] =
    useState<boolean>(false);
  // const [isTournamentCancelModalSheetVisible, setIsTournamentCancelModalSheetVisible] =
  //   useState<boolean>(false); // Moved back to table level
  const [isWidgetRendered, setIsWidgetRendered] = useState(false);
  const [userId, setUserId] = useState<number>(null);
  const [socketClient, setSocketClient] = useState(null);
  const [isTableRebalancePopupVisible, setIsTableRebalancePopupVisible] = useState(false);
  const [isLeavingReminderVisible, setIsLeavingReminderVisible] = useState(false);
  const [isLeavingVisible, setIsLeavingVisible] = useState(false);
  const [tableExitStates, setTableExitStates] = useState<TableExitState[]>([]);
  const [tablesInfo, setTablesInfo] = useState<Array<JoinedRoomProps>>([]);

  // Prevent showing disclaimer again on routeChange as sometimes automatically
  // enters game room directly right after login
  const [hasDisclaimerAlreadyShown, setHasDisclaimerAlreadyShown] = useState<boolean>(false);
  const [isRestrictedModalVisible, setIsRestrictedModalVisible] = useState<boolean>(false);

  const [form] = Form.useForm();

  const layoutRef = useRef<HTMLElement>();
  const tawkMessengerRef = useRef<any>();
  const multipleGameRoomsRef = useRef<any>(null);

  const onLoad = () => {
    setIsWidgetRendered(true);
  };

  const showWidget = () => {
    setTimeout(() => {
      if (tawkMessengerRef.current) {
        tawkMessengerRef.current?.showWidget();
        tawkMessengerRef.current?.minimize();
      }
    }, 500);
  };

  const hideWidget = () => {
    setTimeout(() => {
      if (tawkMessengerRef.current) {
        tawkMessengerRef.current?.hideWidget();
      }
    }, 500);
  };

  const showDisclaimer = () => {
    if (hasDisclaimerAlreadyShown === false) {
      // setIsDisclaimerVisible(true);
      system?.showModalSheet('disclaimer');
      setHasDisclaimerAlreadyShown(true);
      setTimeout(() => {
        // So that the popup shows up if user log out then login again
        setHasDisclaimerAlreadyShown(false);
      }, 5000);
    }
  };

  const isDontShowDisclaimerAgainForUser = () => {
    if (isNil(userId)) {
      return false;
    }
    return window.localStorage.getItem(`dontShowDisclaimerAgain_${userId}`) === 'true';
  };

  const isDontShowIPBlockAgainForUser = () => {
    return window.localStorage.getItem('dontShowIPBlockAgain') === 'true';

    // if (isNil(userId)) {
    //   return false;
    // }
    // return window.localStorage.getItem(`dontShowIPBlockAgain_${userId}`) === 'true';
  };

  const shouldDisplayDisclaimer =
    !hideHeaderRoutes.includes(router.pathname) &&
    user.isLogin() &&
    !isNil(userId) &&
    window.localStorage.getItem('hasAgreedDisclaimer') !== 'true' &&
    !user?.isTelegramBrowser &&
    !user?.isThirdPartyGateway() &&
    !isDontShowDisclaimerAgainForUser();

  const setLanguageByIP = async () => {
    const localStorageLang = localStorage.getItem(CURRENT_LANG_KEY);

    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      const countryCode = data.country_code_iso3;
      // console.log(' @@ layout - BLOCKED_COUNTRIES, countryCode:', BLOCKED_COUNTRIES, countryCode);

      let defaultLang = 'en-US'; // default to eng if there is no match
      for (const [lang, countries] of Object.entries(langToCountryMap)) {
        if (countries.includes(countryCode)) {
          defaultLang = lang;
          break;
        }
      }

      // console.log(' @@ layout - defaultLang, localStorageLang:', defaultLang, localStorageLang);
      if (localStorageLang === '') {
        console.log(' @@ layout - no localStorageLang => setLanguage:', defaultLang);
        language.setLanguage(defaultLang);
      }

      if (
        // BLOCKED_COUNTRIES.includes(countryCode) &&
        // (!user?.isLogin() ||
        //   (user?.isLogin() && !isNil(userId) && !isDontShowIPBlockAgainForUser()))

        !isDontShowIPBlockAgainForUser() &&
        BLOCKED_COUNTRIES.includes(countryCode)
      ) {
        setIsRestrictedModalVisible(true);
        hideWidget();
      }
    } catch (error) {
      console.error(' @@ layout - fetchIP - error:', error);
    }
  };

  useEffect(() => {
    const checkTelegram = () => {
      // console.log(' @@ layout - checkTelegram - isTelegramMiniApp ', isTelegramMiniApp);
      if (isTelegramMiniApp) {
        // notification.success({message: 'tg init()', duration: 1});
        user?.setIsTelegramBrowser(true);

        // * prevent swiping lead to accidentally close the mini app
        if (isTelegramMiniApp) {
          // * must init and mount first
          init();
          swipeBehavior.mount();
          swipeBehavior.disableVertical();
          // notification.info({
          //   message: 'swipeBehavior.mount()',
          // });

          miniApp.mount();
          miniApp.setBackgroundColor(theme.gameRoomBackground);
          miniApp.setHeaderColor(theme.gameRoomBackground);

          viewport.mount();
          viewport.expand();
          // Set body overflow to hidden when running in Telegram Mini App
          document.body.style.overflow = 'hidden';
        }

        return () => {
          swipeBehavior.unmount();
        };
      } else {
        console.log(' layout - not running inside tg');
      }
    };

    // retry after a short delay
    // const timeout = setTimeout(checkTelegram, 1000);
    // return () => clearTimeout(timeout);
    checkTelegram();
  }, []);

  useEffect(() => {
    console.log(' ** layout - checking referralCode from query:', referralCode, 'full query:', router.query);
    if (referralCode !== undefined && referralCode !== null && referralCode !== '') {
      // Check if we've already processed this referral code
      const storedCode = localStorage.getItem('referralCode');
      if (storedCode !== referralCode) {
        console.log(' ** layout - storing referralCode in localStorage:', referralCode);
        localStorage.setItem('referralCode', referralCode as string);
        localStorage.setItem('referralSource', 'url'); // Mark that this came from URL
        
        // Only show login modal if user is not logged in
        if (!user?.isLogin()) {
          system?.showModalSheet('login');
        }
      }
    }
  }, [referralCode, user, system]);

  useEffect(() => {
    setLanguageByIP();
  }, []);

  useEffect(() => {
    const run = async () => {
      if (socketClient) {
        socket.client.socket.on(GAME_EVENTS.GAME_ROOM.INVITE_TO_TOURNAMENT, async data => {
          await pause(3000);
          await user?.refreshPlayerInfo();
          console.log('user?.refreshPlayerInfo in layout', toJS(user?.joinedRooms));

          await pause(1000);

          if (data?.data?.isPlayerCanJoinTableImmediately === false) {
            system?.setTournamentMaxTableReachedData({
              tournamentId: data?.data?.tournamentId,
              tournamentName: data?.data?.tournamentName,
            });
            system?.showModalSheet('tooManyRooms');
          } else {
            // Find the tab bubble ref for this room (you'll need to store refs somewhere)
            const tabBubbleRef = getTabBubbleRefForRoom(data?.roomCode);
            console.log('tournament invite data', data, tabBubbleRef);

            if (!data?.data?.isForceJoinTable && tabBubbleRef) {
              // Emit notification with the tab bubble ref
              system.emitTournamentNotification(tabBubbleRef, data?.roomCode);
            }

            const roomIndex = user?.joinedRooms?.findIndex(
              room => room?.roomCode === data?.roomCode
            );
            const isCurrentActiveTable = roomIndex === activeTableIndex;

            if (data?.data?.isMoveTable && isCurrentActiveTable) {
              setIsTableRebalancePopupVisible(true);
              setTimeout(() => {
                setIsTableRebalancePopupVisible(false);
              }, 2000);
            }

            handleJoinRoom(
              user,
              system,
              socket,
              {
                roomCode: data?.roomCode,
                isAllIn: false,
                isObserver: false,
                isForceJoinTable: data?.data?.isForceJoinTable ?? false,
                isTournament: true,
              },
              t
            );
          }
        });
        socket.client.socket.on(GAME_EVENTS.TOURNAMENT.TOURNAMENT_JOIN_RESULT, data => {
          if (data?.success) {
            if (isTooManyRoomsModalSheetVisible) {
              system?.dismissModalSheet();
            }
          } else {
            // eslint-disable-next-line no-lonely-if
            if (data?.errorCode === 'TOURNAMENT_IS_FINISHED') {
              notification.error({
                message: t('errorCodes:TOURNAMENT_IS_FINISHED'),
              });
            } else {
              notification.error({
                message: t('errorCodes:JOIN_TOURNAMENT_ERROR'),
              });
            }
          }
        });
        socketClient.socket.on(
          GAME_EVENTS.TOURNAMENT.TOURNAMENT_RE_ENTRY_RESULT,
          (data: {tournamentId: number; success: boolean; errorCode: string; message: string}) => {
            console.log('tournament re entry result', data);
            if (data?.success) {
              system?.emitReEntryOnClose(data?.tournamentId);
            } else if (!data?.success && data?.errorCode) {
              notification.error({
                message: t(`errorCodes:${data?.errorCode}`),
              });
            } else {
              notification.success({
                message: t('errorCodes:default.title'),
                description: t('errorCodes:default.description'),
              });
            }
          }
        );
        // Tournament cancel handler moved back to table level
        socketClient.socket.on(GAME_EVENTS.EXIT_TABLE_RESULT, async data => {
          const roomIndex = user?.joinedRooms?.findIndex(room => room?.roomCode === data?.roomCode);
          const exitingTable = user?.joinedRooms?.find(room => room?.roomCode === data?.roomCode);
          const isTournament = exitingTable?.roomType === 'TOURNAMENT';

          console.log('roomIndex exit table', data, roomIndex, activeTableIndex, isTournament);
          try {
            if (data?.success) {
              await user.refreshJoinedRoom();
              
              // For tournament tables, always redirect to tournament page
              if (isTournament) {
                system.hideGameOverlay();
                router.push('/tournament');
              } else {
                // * set query after exiting table for regular tables
                if (user.joinedRooms.length > 0) {
                  const lastRoomCode = user.joinedRooms[user.joinedRooms.length - 1].roomCode;
                  if (user?.isTelegramBrowser) {
                    router.push('/telegram/game-list');
                  } else {
                    router.replace(
                      {
                        pathname: '/home',
                        query: {currentRoom: lastRoomCode},
                      },
                      undefined,
                      {shallow: true}
                    );
                  }
                } else if (user.joinedRooms.length === 0) {
                  if (user?.isTelegramBrowser) {
                    router.push('/telegram/game-list');
                  } else {
                    router.replace(
                      {
                        pathname: '/home',
                      },
                      undefined,
                      {shallow: true}
                    );
                  }
                }
              }
              setIsLeavingVisible(false);
              setTablesInfo(user.joinedRooms);
            } else {
              throw new Error(data?.message);
            }
          } catch (e) {
            // Only show reminder for non-tournament tables
            if (!isTournament) {
              setIsLeavingReminderVisible(true);
            }
            setIsLeavingVisible(false);
          } finally {
            // * in finally instead of data.success because "highest bet" case has to be considered
            setTableExitStates(prevStates =>
              prevStates.filter(room => room.roomCode !== data?.roomCode)
            );
          }
        });
        // Wallet event notifications are now handled globally in socket.ts
      }
    };

    run();

    return () => {
      if (socketClient) {
        socket.client.socket.off(GAME_EVENTS.GAME_ROOM.INVITE_TO_TOURNAMENT);
        socket.client.socket.off(GAME_EVENTS.TOURNAMENT.TOURNAMENT_JOIN_RESULT);
        // socket.client.socket.off(GAME_EVENTS.GAME_ROOM.TOURNAMENT_CANCELLED); // Moved back to table level
        socket.client.socket.off(GAME_EVENTS.EXIT_TABLE_RESULT);
        // socket.client.socket.off(GAME_EVENTS.WALLET_EVENT_NOTIFICATION); // Now handled globally in socket.ts
      }
    };
  }, [socketClient, user, system, activeTableIndex, t, isTooManyRoomsModalSheetVisible]);

  useEffect(() => {
    // * shouldDisplayWidget has to be computed inside useEffect so dependencies can be tracked
    const shouldDisplayWidget = () =>
      user.isLogin() &&
      router.pathname !== '/referral' &&
      !system?.isGameOverlayShown &&
      router.pathname !== '/ranking' &&
      router.pathname !== '/fortune-wheel' &&
      !user?.isTelegramBrowser &&
      router.pathname !== '/history';

    const toggleWidget = (shouldShow: boolean) => {
      shouldShow ? showWidget() : hideWidget();
      // console.log(`## ${shouldShow ? 'should show' : 'should hide'} tawk`);
    };

    toggleWidget(shouldDisplayWidget());
  }, [user.isLogin(), router.pathname, system?.isGameOverlayShown]);

  useEffect(() => {
    const disablePinchZoom = e => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };
    document.addEventListener('touchmove', disablePinchZoom, {passive: false});
    return () => {
      document.removeEventListener('touchmove', disablePinchZoom);
    };
  }, []);

  /**
   * https://stackoverflow.com/questions/10240110/how-do-you-cache-an-image-in-javascript
   */
  const preloadImages = (srcArray: Array<string>) => {
    // const list: Array<any> = [];
    // for (let iii = 0; iii < srcArray.length; iii += 1) {
    //   const img = new Image();
    //   img.onload = function () {
    //     const index = list.indexOf(this);
    //     if (index !== -1) {
    //       // remove image from the array once it's loaded
    //       // for memory consumption reasons
    //       list.splice(index, 1);
    //       if (list.length === 1) {
    //         setIsImagePreloading(false);
    //       }
    //     }
    //   };
    //   list.push(img);
    //   img.src = srcArray[iii];
    // }
    let loadedCount = 0;
    const totalImages = srcArray.length;

    // Use a Map instead of an array for more reliable tracking
    const imageMap = new Map();

    // Load all images in parallel
    for (let i = 0; i < totalImages; i += 1) {
      const img = new Image();

      // Store a unique identifier for each image
      // const imageId = i;
      // imageMap.set(imageId, img);

      // eslint-disable-next-line @typescript-eslint/no-loop-func
      const handleImageComplete = () => {
        loadedCount += 1;

        // Safely remove this image from the map
        // imageMap.delete(imageId);

        // Optional: track when all images are loaded
        if (loadedCount === totalImages) {
          // All images have been loaded
          // setIsImagePreloading(false); // Uncomment if needed
        }
      };

      img.onload = handleImageComplete;
      img.onerror = handleImageComplete;

      // Start loading the image
      img.src = srcArray[i];
    }
  };

  useEffect(() => {
    const allImages: Array<string> = [];

    allImages.push('/images-mobile/game-room/tables/horizontal/web3/blue-table-regular.webp');
    allImages.push('/images-mobile/game-room/tables/horizontal/web3/red-table-regular.webp');
    allImages.push('/images-mobile/game-room/tables/horizontal/web3/green-table-regular.webp');
    allImages.push('/images-mobile/game-room/tables/vertical/blue-table.webp');
    allImages.push('/images-mobile/game-room/tables/vertical/red-table.webp');
    allImages.push('/images-mobile/game-room/tables/vertical/green-table.webp');

    const suits = [SUIT.SPADE, SUIT.HEART, SUIT.CLUB, SUIT.DIAMOND];
    const values = [];
    for (let iii = 2; iii <= 14; iii += 1) values.push(iii);
    suits.forEach(suit => {
      values.forEach(value => {
        allImages.push(getPokerImage({suit, rank: value, isDesktop}));
      });
    });

    allImages.push('/images-mobile/game-room/empty_seat.svg');
    allImages.push('/images-mobile/game-room/buyInModal/smallCoin.svg');
    allImages.push('/icon/blue-diamond-2.png');
    allImages.push('/images-mobile/game-room/result-render/handTypes/flush.webp');
    allImages.push('/images-mobile/game-room/result-render/handTypes/fullHouse.webp');
    allImages.push('/images-mobile/game-room/result-render/handTypes/hiCard.webp');
    allImages.push('/images-mobile/game-room/result-render/handTypes/onePair.webp');
    allImages.push('/images-mobile/game-room/result-render/handTypes/quad.webp');
    allImages.push('/images-mobile/game-room/result-render/handTypes/royalFlush.webp');
    allImages.push('/images-mobile/game-room/result-render/handTypes/set.webp');
    allImages.push('/images-mobile/game-room/result-render/handTypes/straight.webp');
    allImages.push('/images-mobile/game-room/result-render/handTypes/straightFlush.webp');
    allImages.push('/images-mobile/game-room/result-render/handTypes/twoPairs.webp');

    preloadImages(allImages);
  }, []);

  useEffect(() => {
    // * playerThirdPartyInfo can be incorrect here, moved profileSettings to another useEffect
    const handleRouteChange = (url, {shallow}) => {
      if (!user.getPlayerToken()) {
        if (shouldRedirect(router.pathname)) {
          system.hideGameOverlay();
          router.push({
            pathname: '/home',
          });
        }
      } else if (shouldDisplayDisclaimer) {
        showDisclaimer();
      }
      if (router.query.isVerified === 'false' && !user?.isTelegramBrowser && !user?.isThirdPartyGateway()) {
        system.showModalSheet('profileSettings');
      }
      // console.log(
      //   `App is changing to ${url} ${shallow ? 'with' : 'without'} shallow routing from ${
      //     router.pathname
      //   }`
      // );
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    if (shouldDisplayDisclaimer) {
      showDisclaimer();
    }

    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, user, hasDisclaimerAlreadyShown, userId]);

  const handleDepositModalSheet = () => {
    if (system?.modalSheetType === 'depositWithdraw') {
      setIsDepositModalSheetVisible(true);
    } else {
      setIsDepositModalSheetVisible(false);
    }
  };

  const handleSignModalSheet = () => {
    if (system?.modalSheetType === 'walletConnectSignMessage') {
      setIsSignMessageModalVisible(true);
    } else {
      setIsSignMessageModalVisible(false);
    }
  };

  const handleDisclaimerModalSheet = () => {
    if (system?.modalSheetType === 'disclaimer') {
      setIsDisclaimerModalSheetVisible(true);
    } else {
      setIsDisclaimerModalSheetVisible(false);
    }
  };

  useEffect(() => {
    autorun(() => {
      // console.log('autorun in layout');
      if (language?.currentLanguage !== i18n?.language) {
        i18n.changeLanguage(language.currentLanguage);
      }

      if (JSON.stringify(tablesInfo) !== JSON.stringify(user.joinedRooms)) {
        setTablesInfo(user.joinedRooms);
      }

      if (!system?.hasInitGamePageShown && user?.joinedRooms?.length > 0) {
        // system.showGameOverlay();
        system.hasInitGamePageShown = true;
      }
      if (system?.isGameOverlayShown) {
        setActiveTab(TAB.GAME_ROOMS);
        hideWidget();
      } else {
        setActiveTab(TAB.CONTENT);
        if (user.isLogin()) {
          showWidget();
        }
      }

      if (system?.activeTableIndex !== activeTableIndex) {
        setActiveTableIndex(system?.activeTableIndex);
      }

      if (user?.getPlayerId() !== userId) {
        setUserId(user?.getPlayerId());
      }

      if (socket?.client !== socketClient) {
        setSocketClient(socket?.client);
      }

      if (system?.modalSheetType === 'tooManyRooms') {
        setIsTooManyRoomsModalSheetVisible(true);
      } else {
        setIsTooManyRoomsModalSheetVisible(false);
      }

      // Tournament cancel modal moved back to table level

      // * hideWidget doesn't work here

      setSystemModal(system.modalText);

      handleDepositModalSheet();

      handleSignModalSheet();

      // * to prevent profile setting modal and disclaimer modal show at the same time for new user
      if (user?.playerThirdPartyInfo?.isAccountVerified) {
        handleDisclaimerModalSheet();
      }

      if (
        !shouldNotShowInitProfileSetting(router.pathname) &&
        user?.playerThirdPartyInfo?.isAccountVerified === false &&
        (!user?.isThirdPartyGateway() || isMerchantGateway()) && // Allow profile setup for merchant gateway users
        // TODO @@ telegram - profileSettings is opened accidentally when user clicks money row in telegram
        // !user?.isTelegramBrowser
        router?.pathname !== '/telegram'
      ) {
        console.log('autorun - showModalSheet - profileSettings');
        system.showModalSheet('profileSettings');
      }
    });
  }, []);

  useEffect(() => {
    if (user?.isLogin() === false) {
      // console.log('should hide tawk');
      setTimeout(() => {
        hideWidget();
      }, 1000);
    }
  }, [user?.isLogin()]);

  useEffect(() => {
    if (activeTab === TAB.CONTENT) {
      system.isGameOverlayShown = false;
    } else if (activeTab === TAB.GAME_ROOMS) {
      system.isGameOverlayShown = true;
    }
  }, [activeTab]);

  const renderMobileHeader = useMemo(() => {
    if (hideHeaderRoutes.includes(router.pathname)) return null;
    if (activeTab === TAB.GAME_ROOMS) return null;

    // return <HeaderMobile />;
    // console.log('renderMobileHeader')
    return <MobileHeader />;
  }, [router.pathname, activeTab]);

  const getMarginTop = () => {
    if (isDesktop) {
      return 126;
    }

    return 0;
  };

  const handleTabClick = (tabNumber: number) => {
    setActiveTab(tabNumber);
  };

  const renderDesktopSider = useMemo(() => {
    if (hideHeaderRoutes.includes(router.pathname)) return null;
    if (activeTab === TAB.GAME_ROOMS) return null;
    return <SiderBar />;
  }, [router.pathname, activeTab]);

  const roomNumbers = tablesInfo.map(info => info?.roomCode || null);

  const {wrappedFn: handleQuitTable} = useDisableDuplicateClick(async () => {
    const roomCode = roomNumbers[activeTableIndex];
    const currentTable = tablesInfo[activeTableIndex];
    const isTournament = currentTable?.roomType === 'TOURNAMENT';

    setTableExitStates(prevStates => {
      const existingRoom = prevStates.find(room => room.roomCode === roomCode);

      if (existingRoom) {
        return prevStates.map(room =>
          room.roomCode === roomCode ? {...room, isExiting: true} : room
        );
      }
      return [...prevStates, {roomCode, isExiting: true}];
    });

    console.log('multipleGameRoomsRef.current', multipleGameRoomsRef.current);

    await multipleGameRoomsRef.current.quitTable(roomNumbers[activeTableIndex]);
    
    // If it's a tournament, redirect to tournament page after quit
    if (isTournament) {
      // Hide game overlay first to ensure navigation works
      system.hideGameOverlay();
      setTimeout(() => {
        router.push('/tournament');
      }, 100);
    }
    // Callback is handled in another WS subscription
  }, 3000);

  console.log('multipleGameRoomsRef.current render', multipleGameRoomsRef.current);

  const leaveRoomPopupButtons = useMemo(() => {
    const currentTable = tablesInfo[activeTableIndex];
    const isTournament = currentTable?.roomType === 'TOURNAMENT';
    
    return [
      {
        loading: tableExitStates.find(room => room.roomCode === roomNumbers[activeTableIndex])
          ?.isExiting,
        isBlue: true,
        buttonFunction: () => {
          handleQuitTable();
        },
        buttonLabel: isTournament ? t('game_room:back_to_lobby') : t('game_room:cash_out'),
      },
      {
        isBlue: false,
        buttonFunction: () => {
          setIsLeavingVisible(false);
        },
        buttonLabel: t('game_room:continue_game'),
      },
    ];
  }, [tableExitStates, roomNumbers, activeTableIndex, multipleGameRoomsRef.current, tablesInfo]);

  const leaveRoomReminderPopupButtons = useMemo(() => {
    if (isTooManyRoomsModalSheetVisible) {
      return [
        {
          buttonLabel: t('common:confirm'),
          buttonFunction: () => {
            setIsLeavingReminderVisible(false);
          },
          isBlue: true,
        },
      ];
    }

    return [
      {
        buttonLabel: t('game_room:back_to_home'),
        buttonFunction: () => {
          system?.hideGameOverlay();
          setIsLeavingReminderVisible(false);
        },
        isBlue: true,
      },
      {
        buttonLabel: t('game_room:not_leaving_temporarily'),
        buttonFunction: () => {
          setIsLeavingReminderVisible(false);
        },
        isBlue: false,
      },
    ];
  }, [system, t, isTooManyRoomsModalSheetVisible]);

  return (
    <ConfigProvider locale={langMap[i18n.language]}>
      <Layout ref={layoutRef} className={classes.layout}>
        {isDesktop ? renderDesktopSider : null}
        <Layout
          className={classNames(
            classes.antLayout,
            isDesktop &&
              !system?.isGameOverlayShown &&
              !disableDesktopPaddingRoutes.includes(router.pathname) &&
              'desktop-padding'
          )}
        >
          <div style={{zIndex: 2}}>{renderMobileHeader}</div>
          {/* // TODO @@ double check if both 100% would cause other bugs  */}
          <div style={{zIndex: 1, marginTop: getMarginTop(), height: '100%'}}>
            {activeTab === TAB.CONTENT ? (
              <section
                style={{
                  display: activeTab === TAB.CONTENT ? 'flex' : 'none',
                  height: '100%',
                }}
              >
                <Content className={classes.content}>{children}</Content>
              </section>
            ) : null}
            <section
              style={{
                display: activeTab === TAB.GAME_ROOMS ? 'flex' : 'none',
              }}
            >
              <MultipleGameRooms
                ref={multipleGameRoomsRef}
                tableExitStates={tableExitStates}
                setTableExitStates={setTableExitStates}
                isLeavingVisible={isLeavingVisible}
                setIsLeavingVisible={setIsLeavingVisible}
              />
            </section>
          </div>
        </Layout>
        <VerificationBoard />
        <CustomPopup
          open={Boolean(systemModal)}
          closable
          onCancel={() => {
            system.dismissModal();
          }}
          title={t('common:system_message')}
          width={300}
          centered={false}
        >
          {systemModal}
        </CustomPopup>
        {/* DepositWithdrawModalSheet is moved to layout so it could be opened in game room */}
        <DepositWithdrawModalSheet
          isModalSheetOpen={isDepositModalSheetVisible}
          onModalSheetClose={() => system?.dismissModalSheet()}
        />
        <WalletConnectSignMessageModalSheet
          isModalSheetOpen={isSignMessageModalVisible}
          onModalSheetClose={() => system?.dismissModalSheet()}
        />
        <DisclaimerModal
          isModalSheetOpen={isDisclaimerModalSheetVisible}
          onModalSheetClose={() => system?.dismissModalSheet()}
        />

        <TooManyRoomsModalSheet
          isModalSheetOpen={isTooManyRoomsModalSheetVisible}
          onModalSheetClose={() => system?.dismissModalSheet()}
        />

        {/* Tournament cancel modal moved back to table level */}
        {/* <CustomPopup
          title={t('disclaimer:title')}
          open={isDisclaimerVisible}
          closable={false}
          closeIcon={false}
          footer={
            <GradientButton style={{height: 50}} onClick={form.submit}>
              {t('common:confirm')}
            </GradientButton>
          }
        >
          <Form
            form={form}
            onFinish={values => {
              window.localStorage.setItem(`hasAgreedDisclaimer`, 'true');
              window.localStorage.setItem('dontShowIPBlockAgain', 'true');
              // window.localStorage.setItem(`dontShowIPBlockAgain_${user.getPlayerId()}`, 'true');
              setIsDisclaimerVisible(false);

              if (values.dontShowDisclaimerAgain) {
                window.localStorage.setItem(
                  `dontShowDisclaimerAgain_${user.getPlayerId()}`,
                  'true'
                );
              }
            }}
          >
            <p>{t('disclaimer:message')}</p>
            <p style={{color: '#c50000'}}>{t('disclaimer:countryList')}</p>

            <Form.Item
              name="agreeDisclaimer"
              valuePropName="checked"
              rules={[
                {
                  validator(rule, value, callback) {
                    if (!value) {
                      return Promise.reject(t('disclaimer:required_message'));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Checkbox style={{color: theme.secondaryTextColor}}>
                {t('disclaimer:checkbox_message')}
              </Checkbox>
            </Form.Item>

            <Form.Item name="dontShowDisclaimerAgain" valuePropName="checked">
              <Checkbox style={{color: theme.secondaryTextColor}}>
                {t('common:dont_show_again')}
              </Checkbox>
            </Form.Item>
          </Form>
        </CustomPopup> */}
        <CustomPopup
          open={isRestrictedModalVisible}
          closable={false}
          title={t('location_restricted_title')}
          width={300}
          bodyProps={{style: {paddingBottom: 0}}}
          centered
        >
          {t('location_restricted_content')}
          <GradientButton
            style={{height: 50, whiteSpace: 'normal'}}
            onClick={() => {
              window.localStorage.setItem('dontShowIPBlockAgain', 'true');
              setIsRestrictedModalVisible(false);
            }}
          >
            {t('common:i_am_not_located_in_the_restricted_country')}
          </GradientButton>
        </CustomPopup>
        {isProd && (
          <TawkMessengerReact
            propertyId="674699d54304e3196ae92e41"
            widgetId="1idlshr9i"
            ref={tawkMessengerRef}
            onload={onLoad}
          />
        )}
        <TournamentNotificationsContainer />

        <CustomPopup
          open={isTableRebalancePopupVisible}
          closable={false}
          title={t('tournament:table_rebalancing')}
          width={300}
          bodyProps={{style: {paddingBottom: 0}}}
          centered
        >
          <Lottie
            isClickToPauseDisabled
            options={{
              loop: true,
              autoplay: true,
              animationData: tableRebalance,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
              },
            }}
          />
        </CustomPopup>

        <CustomPopup
          title={t('game_room:reminder')}
          width={300}
          open={isLeavingReminderVisible}
          closable={false}
          centered={false}
          buttons={leaveRoomReminderPopupButtons}
        >
          <span className={classes.modalTitle}>
            {isTooManyRoomsModalSheetVisible
              ? t('game_room:leave_table_with_highest_bet_error')
              : t('game_room:are_you_sure_leave_table')}
          </span>
        </CustomPopup>

        <CustomPopup
          onCancel={() => {
            setIsLeavingVisible(false);
          }}
          open={isLeavingVisible}
          width={300}
          title={t('game_room:confirm_leave_msg')}
          buttons={leaveRoomPopupButtons}
          closable
        >
          {/* TODO: need update total_won_prize */}
          <div className={classes.modalImageDiv}>
            <img src="/images-mobile/game-room/coin.svg" alt="" />
          </div>
        </CustomPopup>
      </Layout>
    </ConfigProvider>
  );
};

export default LayoutBase;
